import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Stack } from '@mui/system';
import { useParams } from 'react-router-dom';
import { jsonPathToValue } from '../../utils/json';
import { RootState } from '../../redux/store';
import useMetaData from '../../hooks/useMetaData';
import { getCustomer } from '../../services/vehicles';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import FieldList from './FieldList';
import TabLoader from './TabLoader';
import applyType from '../../utils/metadataUtils';

const Customer = () => {
  const [data, setData] = useState<any>();
  const { reservationId } = useParams<{ reservationId: string }>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.customerDetailsTabs);
  const email = useSelector((state: RootState) => state.vehicle.data.email);

  useEffect(() => {
    if (email) {
      getCustomer(email, reservationId!).then((response) => setData(response));
    }
  }, [email]);

  if (!metaData || !data) {
    return (
      <>
        <TabLoader titleWidth={150} rowCount={6} />
        <TabLoader titleWidth={100} rowCount={9} />
      </>
    );
  }
  const customer =
    metaData?.customerDetails?.rows?.map((row: any) => ({
      field: row.propertyName,
      value: applyType(jsonPathToValue(data, row.property), row.type),
    })) || [];

  const profile =
    metaData?.profile?.rows?.map((row: any) => {
      return { field: row.propertyName, value: jsonPathToValue(data, row.property) };
    }) || [];

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" pt={2.5} pr={1.5} pl={1.5} pb={1}>
        <Typography fontSize={12} fontWeight={500} sx={{ textTransform: 'uppercase' }}>
          {metaData?.customerDetails?.name}
        </Typography>
      </Stack>
      <FieldList fields={customer} />
      <Stack direction="row" alignItems="center" justifyContent="space-between" pt={3.2} pr={1.5} pl={1.5} pb={0.9}>
        <Typography fontSize={12} fontWeight={500} sx={{ textTransform: 'uppercase' }}>
          {metaData?.profile?.name}
        </Typography>
      </Stack>

      <FieldList fields={profile} />
    </Box>
  );
};

export default Customer;
